{
  "CANNED_MGMT": {
    "HEADER": "미리 준비된 답변",
    "LEARN_MORE": "미리 준비된 답변에 대해 알아보기",
    "DESCRIPTION": "미리 준비된 응답은 대화에 신속하게 응답할 수 있도록 도와주는 미리 작성된 응답 템플릿입니다. 에이전트는 대화 중에 '/' 문자 뒤에 단축 코드를 입력하여 미리 준비된 응답을 삽입할 수 있습니다. ",
    "COUNT": "{n}개의 미리 준비된 응답 | {n}개의 미리 준비된 응답",
    "HEADER_BTN_TXT": "미리 준비된 응답 추가",
    "LOADING": "미리 준비된 응답을 가져오는 중...",
    "SEARCH_PLACEHOLDER": "미리 준비된 응답 검색...",
    "NO_RESULTS": "검색과 일치하는 미리 준비된 응답이 없습니다",
    "SEARCH_404": "이 쿼리와 일치하는 항목이 없습니다.",
    "LIST": {
      "404": "이 계정에는 미리 준비된 답변이 없습니다.",
      "TITLE": "미리 준비된 답변 관리",
      "DESC": "미리 준비된 응답은 대화에 빠르게 답변을 보낼 수 있는 미리 정의된 응답 템플릿입니다.",
      "TABLE_HEADER": {
        "SHORT_CODE": "단축 코드",
        "CONTENT": "내용",
        "ACTIONS": "액션"
      }
    },
    "ADD": {
      "TITLE": "미리 준비된 응답 추가",
      "DESC": "미리 준비된 응답은 대화에 빠르게 답변을 보낼 수 있는 미리 정의된 응답 템플릿입니다.",
      "CANCEL_BUTTON_TEXT": "취소",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "단축 코드",
          "PLACEHOLDER": "단축 코드를 입력하십시오.",
          "ERROR": "단축 코드가 필요합니다."
        },
        "CONTENT": {
          "LABEL": "메시지",
          "PLACEHOLDER": "나중에 템플릿으로 사용할 메시지를 작성하십시오.",
          "ERROR": "메시지가 필요합니다."
        },
        "SUBMIT": "제출"
      },
      "API": {
        "SUCCESS_MESSAGE": "미리 준비된 응답이 성공적으로 추가되었습니다.",
        "ERROR_MESSAGE": "Woot 서버에 연결할 수 없습니다. 다시 시도하십시오."
      }
    },
    "EDIT": {
      "TITLE": "미리 준비된 응답 수정",
      "CANCEL_BUTTON_TEXT": "취소",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "단축 코드",
          "PLACEHOLDER": "단축 코드를 입력하십시오.",
          "ERROR": "단축 코드가 필요합니다."
        },
        "CONTENT": {
          "LABEL": "메시지",
          "PLACEHOLDER": "나중에 템플릿으로 사용할 메시지를 작성하십시오.",
          "ERROR": "메시지가 필요합니다."
        },
        "SUBMIT": "제출"
      },
      "BUTTON_TEXT": "수정",
      "API": {
        "SUCCESS_MESSAGE": "미리 준비된 응답이 성공적으로 업데이트되었습니다.",
        "ERROR_MESSAGE": "Woot 서버에 연결할 수 없습니다. 다시 시도하십시오."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "삭제",
      "API": {
        "SUCCESS_MESSAGE": "미리 준비된 응답이 성공적으로 삭제되었습니다.",
        "ERROR_MESSAGE": "Woot 서버에 연결할 수 없습니다. 다시 시도하십시오."
      },
      "CONFIRM": {
        "TITLE": "삭제 확인",
        "MESSAGE": "삭제하시겠습니까? ",
        "YES": "예, 삭제합니다. ",
        "NO": "아니요, 유지합니다. "
      }
    }
  }
}
